<template>
    <div class="global-container">
        <div class="second-header-wrap">
            <el-button v-if="!isEnd" style="margin-bottom: 10px;" type="primary" @click.native="$router.push({path: 'outerQuestionnaire', query: {stuName: signupInfo.stuName, noticeId, schoolId, loginPhone, fromEdit: 1}})">编辑</el-button>
            <el-button @click="print()" type="primary">打印</el-button>
        </div>
        <div class="content" id="content" ref="print">
            <div>
                <span class="order-no" v-if="hasName('applyNo')">报名编号：{{signupInfo.applyNo}}</span>
                <span class="order-no" v-else-if="orderNo">预报名号：{{orderNo}}</span>
                <el-tag v-if="state != 0" type="success">已报名</el-tag>
            </div>
            <div class="print-header">
                {{createYear}}年&nbsp;&nbsp;{{schoolName}}&nbsp;&nbsp;新生招生登记表
            </div>
            <div class="section section--general-info">
                <div class="section-header">
                    基本信息
                    <div class="section-header__bottom-block">
                    </div>
                </div>
                <div class="section-body">
                    <div v-if="hasName('childPhoto') && signupInfo.childPhotoPhoto && signupInfo.childPhotoPhoto.length !== 0" class="section-body__left-block" style="text-align: center;">
                        <image-previewer tag="richtext" viewclass="student-photo" :images="[signupInfo.childPhotoPhoto[0]]">
                            <img class="student-photo" :src="signupInfo.childPhotoPhoto[0].photoUrl"/>
                        </image-previewer>
                    </div>
                    <div class="section-body__right-block">
                        <div class="student-info-item base-info">
                            <div class="student-name">{{signupInfo.stuName}}</div>
                        </div>
                        <div class="student-info-item base-info">
                            <span class="student-info-item__label">性别：</span>
                            <span class="student-info-item__value">{{signupInfo.gender  === 1 ? '男' : '女' }}</span>
                        </div>
                        <div class="student-info-item base-info">
                            <span class="student-info-item__label">出生日期：</span>
                            <span class="student-info-item__value">{{signupInfo.birthday}}</span>
                        </div>
                        <div class="student-info-item base-info">
                            <span class="student-info-item__label">身份证/护照号：</span>
                            <span class="student-info-item__value">{{signupInfo.idCard}}</span>
                        </div>

                        <div class="student-info-item base-info" v-if="hasName('stature')">
                            <span class="student-info-item__label">身高：</span>
                            <span class="student-info-item__value">{{signupInfo.stature }}</span>
                        </div>
                        <div class="student-info-item base-info" v-if="hasName('weight')">
                            <span class="student-info-item__label">体重：</span>
                            <span class="student-info-item__value">{{signupInfo.weight }}</span>
                        </div>

                        <div class="student-info-item" v-if="hasName('interests')">
                            <span class="student-info-item__label">兴趣爱好特长：</span>
                            <span class="student-info-item__value">{{signupInfo.interests}}</span>
                        </div>
                         <div class="student-info-item" v-if="hasName('familyJyln')">
                            <span class="student-info-item__label">家庭教育理念：</span>
                            <span class="student-info-item__value">{{signupInfo.familyJyln}}</span>
                        </div>
                         <div class="student-info-item" v-if="hasName('childJynYdsm')">
                            <span class="student-info-item__label">孩子近一年来的阅读书目：</span>
                            <span class="student-info-item__value">{{signupInfo.childJynYdsm}}</span>
                        </div>
                         <div class="student-info-item" v-if="hasName('childZxhHdxm')">
                            <span class="student-info-item__label">孩子最喜欢的亲子活动项目：</span>
                            <span class="student-info-item__value">{{signupInfo.childZxhHdxm}}</span>
                        </div>
                        <div class="student-info-item" v-if="hasName('nation')">
                            <span class="student-info-item__label">民族：</span>
                            <span class="student-info-item__value">{{signupInfo.nation}}</span>
                        </div>
                        <div class="student-info-item" v-if="hasName('nativePlace')">
                            <span class="student-info-item__label">籍贯：</span>
                            <span class="student-info-item__value">{{signupInfo.nativePlace}}</span>
                        </div>
                        <div v-if="hasName('graduateSchool')" class="student-info-item">
                            <span class="student-info-item__label">毕业学校：</span>
                            <span class="student-info-item__value">{{signupInfo.graduateSchool}}</span>
                        </div>
                        <div v-if="hasName('graduateClass')" class="student-info-item">
                            <span class="student-info-item__label">所在班级：</span>
                            <span class="student-info-item__value">{{signupInfo.graduateClass}}</span>
                        </div>
                        <div v-if="hasName('homeCity')" class="student-info-item">
                            <span class="student-info-item__label">家庭住址：</span>
                            <span class="student-info-item__value">{{signupInfo.homeProvName}}&nbsp;&nbsp;{{signupInfo.homeCityName}}&nbsp;&nbsp;{{signupInfo.homeCountyName}}&nbsp;&nbsp;{{signupInfo.homeAddress}}</span>
                        </div>
                        <div v-if="hasName('birthSite')" class="student-info-item">
                            <span class="student-info-item__label">出生地：</span>
                            <span class="student-info-item__value">{{signupInfo.birthProvName}}&nbsp;&nbsp;{{signupInfo.birthCityName}}&nbsp;&nbsp;{{signupInfo.birthCountyName}}&nbsp;&nbsp;{{signupInfo.birthAddress}}</span>
                        </div>
                        <div v-if="hasName('nodeType')" class="student-info-item">
                            <span class="student-info-item__label">户口类型：</span>
                            <span class="student-info-item__value">{{signupInfo.nodeType | getNodeTypeText }}</span>
                        </div>
                        <div v-if="hasName('isTeachAreaStu')" class="student-info-item">
                            <span class="student-info-item__label">是否施教区学生：</span>
                            <span class="student-info-item__value">{{signupInfo.isTeachAreaStu==1?'是':'否'}}</span>
                        </div>
                        <div v-if="hasName('birthCertificateNo')" class="student-info-item">
                            <span class="student-info-item__label">出生证编号：</span>
                            <span class="student-info-item__value">{{signupInfo.birthCertificateNo }}</span>
                        </div>
                        <div v-if="hasName('isSingleton')" class="student-info-item">
                            <span class="student-info-item__label">是否独生子女：</span>
                            <span class="student-info-item__value">{{signupInfo.isSingleton === 1 ? '是' : '否'}}</span>
                        </div>
                    </div>
                </div>

            </div>

            <div class="section section--general-info">
                <div class="section-header">
                    证明材料
                    <div class="section-header__bottom-block">
                    </div>
                </div>
                <div class="section-body">
                    <div class="line-container">
                        <div class="pic-container" v-if="hasName('birthProve') && signupInfo.birthProve === 1">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>出生证明</span></span>
                            <span class="pic">
                            <image-previewer tag="richtext" viewclass="image-container" :images="signupInfo.birthProvePhoto">
                                <img v-for="(picItem, picIndex) in signupInfo.birthProvePhoto" class="image-container"
                                     :src="picItem.photoUrl"/>
                            </image-previewer>
                        </span>
                        </div>
                        <div class="pic-container" v-if="hasName('vaccinateProve') && signupInfo.vaccinateProve === 1">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>接种证明</span></span>
                            <span class="pic">
                            <image-previewer tag="richtext" viewclass="image-container" :images="signupInfo.vaccinateProvePhoto">
                                <img v-for="(picItem, picIndex) in signupInfo.vaccinateProvePhoto" class="image-container"
                                     :src="picItem.photoUrl"/>
                            </image-previewer>
                        </span>
                        </div>
                    </div>

                    <div class="line-container">
                        <div class="pic-container" v-if="hasName('isBigBoy')">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>非大孩</span></span>
                            <span class="pic">
                            <span>{{signupInfo.isBigBoy === 1 ? '是' : '否'}}</span>
                        </span>
                        </div>
                        <!-- <div class="pic-container" v-if="hasName('isBigBoy') && signupInfo.isBigBoy === 1">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>准生证</span></span>
                            <span class="pic">
                                <image-previewer tag="richtext" viewclass="image-container" :images="signupInfo.isBigBoyPhoto">
                                    <img v-for="(picItem, picIndex) in signupInfo.isBigBoyPhoto" class="image-container"
                                         :src="picItem.photoUrl"/>
                                </image-previewer>
                            </span>
                        </div> -->
                    </div>

                    <div class="line-container">
                        <div class="pic-container" v-if="hasName('isSingleParent')">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>单亲家庭</span></span>
                            <span class="pic">
                            <span>{{signupInfo.isSingleParent === 1 ? '是' : '否'}}</span>
                        </span>
                        </div>
                        <div class="pic-container" v-if="hasName('isSingleParent') && signupInfo.isSingleParent === 1">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>单亲家庭证明</span></span>
                            <span class="pic" v-if="signupInfo.isSingleParentPhoto && signupInfo.isSingleParentPhoto.length !== 0">
                                <image-previewer tag="richtext" viewclass="image-container" :images="signupInfo.isSingleParentPhoto">
                                    <img v-for="(picItem, picIndex) in signupInfo.isSingleParentPhoto" class="image-container"
                                         :src="picItem.photoUrl"/>
                                </image-previewer>
                            </span>
                            <span class="pic" v-else>无</span>
                        </div>
                    </div>

                    <div class="line-container">
                        <div class="pic-container" v-if="hasName('isMajorDis')">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>重大疾病或过敏史</span></span>
                            <span class="pic">
                            <span>{{signupInfo.isMajorDis === 1 ? signupInfo.majorDisRemark : '无'}}</span>
                        </span>
                        </div>
                        <div class="pic-container" v-if="hasName('isMajorDis') && signupInfo.isMajorDis === 1">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>大病及过敏证明</span></span>
                            <span class="pic">
                                <image-previewer tag="richtext" viewclass="image-container" :images="signupInfo.isMajorDisPhoto">
                                    <img v-for="(picItem, picIndex) in signupInfo.isMajorDisPhoto" class="image-container"
                                         :src="picItem.photoUrl"/>
                                </image-previewer>
                            </span>
                        </div>
                    </div>

                    <div class="line-container">
                        <div class="pic-container" v-if="hasName('isOnlyChild')">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>是否独生子女</span></span>
                            <span class="pic">
                            <span>{{signupInfo.isOnlyChild === 1 ? '是' : '否'}}</span>
                        </span>
                        </div>
                        <div class="pic-container" v-if="hasName('isOnlyChild') && signupInfo.isOnlyChild === 1">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>独生子女证</span></span>
                            <span class="pic">
                                <image-previewer tag="richtext" viewclass="image-container" :images="signupInfo.isOnlyChildPhoto">
                                    <img v-for="(picItem, picIndex) in signupInfo.isOnlyChildPhoto" class="image-container"
                                         :src="picItem.photoUrl"/>
                                </image-previewer>
                            </span>
                        </div>
                    </div>

                    <div class="line-container">
                        <div class="pic-container" v-if="hasName('isSoldierChild')">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>是否现役军人子女</span></span>
                            <span class="pic">
                            <span>{{signupInfo.isSoldierChild === 1 ? '是' : '否'}}</span>
                        </span>
                        </div>
                        <div class="pic-container" v-if="hasName('isSoldierChild') && signupInfo.isSoldierChild === 1">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>军人子女证明</span></span>
                            <span class="pic">
                            <image-previewer tag="richtext" viewclass="image-container" :images="signupInfo.isSoldierChildPhoto">
                                <img v-for="(picItem, picIndex) in signupInfo.isSoldierChildPhoto" class="image-container"
                                     :src="picItem.photoUrl"/>
                            </image-previewer>
                        </span>
                        </div>
                    </div>
                </div>
            </div>


            <div v-if="hasName('parentsInfo')" class="section section--parents-info">
                <div class="section-header">
                    监护人信息
                    <div class="section-header__bottom-block">
                    </div>
                </div>
                <div class="section-body section-body--parent">
                    <div class="parent-info-container" v-if="signupInfo.father">
                        <div class="info-item" v-if="hasName('parentName')">
                            <span class="info-item__label">第一监护人：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.father.parentName}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('nickCode')">
                            <span class="info-item__label">与孩子关系：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.father.nickName}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('dutyType')">
                            <span class="info-item__label">职业类型：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.father.dutyTypeName}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('parentWorkPlace')">
                            <span class="info-item__label">工作单位：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.father.workPlace}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('duty')">
                            <span class="info-item__label">职务：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.father.duty}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('parentIdCard')">
                            <span class="info-item__label">身份证号：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.father.idCard}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('parentEducation')">
                            <span class="info-item__label">学历：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.father.education}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('parentMobile')">
                            <span class="info-item__label">手机号码：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.father.phone}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('residenceAddress')">
                            <span class="info-item__label">户籍地址：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.father.resProvName}}&nbsp;{{signupInfo.father.resCityName}}&nbsp;{{signupInfo.father.resCountyName}}&nbsp;{{signupInfo.father.residenceAddress}}
                                    </span>
                                </span>
                        </div>
                    </div>
                    <div class="parent-info-container" v-if="signupInfo.mather">
                        <div class="info-item" v-if="hasName('parentName')">
                            <span class="info-item__label">第二监护人：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.mather.parentName}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('nickCode')">
                            <span class="info-item__label">与孩子关系：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.mather.nickName}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('dutyType')">
                            <span class="info-item__label">职业类型：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.mather.dutyTypeName}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('parentWorkPlace')">
                            <span class="info-item__label">工作单位：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.mather.workPlace}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('duty')">
                            <span class="info-item__label">职务：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.mather.duty}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('parentIdCard')">
                            <span class="info-item__label">身份证号：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.mather.idCard}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('parentEducation')">
                            <span class="info-item__label">学历：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.mather.education}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('parentMobile')">
                            <span class="info-item__label">手机号码：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.mather.phone}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('residenceAddress')">
                            <span class="info-item__label">户籍地址：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.mather.resProvName}}&nbsp;{{signupInfo.mather.resCityName}}&nbsp;{{signupInfo.mather.resCountyName}}&nbsp;{{signupInfo.mather.residenceAddress}}
                                    </span>
                                </span>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="hasName('healthTravelCode')" class="section section--parents-info">
                <div class="section-header">
                    健康码及行程码
                    <div class="section-header__bottom-block">
                    </div>
                </div>
                <div class="section-body">
                    <div class="pic-container">
                        <span class="pic">
                            <image-previewer tag="richtext" viewclass="image-container" :images="signupInfo.healthTravelPics">
                                <img v-for="(picItem, picIndex) in signupInfo.healthTravelPics" class="image-container"
                                     :src="picItem.photoUrl || picItem.fileUrl"/>
                            </image-previewer>
                        </span>
                    </div>
                </div>
            </div>

            <div class="section section--address-info">
                <div class="section-header">
                    户籍信息
                    <div class="section-header__bottom-block">
                    </div>
                </div>
                <div class="section-body">
                    <div class="info-item" v-if="hasName('houseHolder')">
                        <span class="info-item__label">户主姓名：</span>
                        <span class="info-item__value">
                                <span>{{signupInfo.stuPropertyList[0].houseHolder}}</span>
                            </span>
                    </div>

                    <div class="info-item" v-if="hasName('holderRelation')">
                        <span class="info-item__label">与孩子关系：</span>
                        <span class="info-item__value">
                                <span>{{signupInfo.stuPropertyList[0].holderRelation | parseHolderRelation}}</span>
                            </span>
                    </div>

                    <div class="info-item" v-if="hasName('settleTime')">
                        <span class="info-item__label">学生落户时间：</span>
                        <span class="info-item__value">
                                <span>{{signupInfo.stuPropertyList[0].settleTime}}</span>
                            </span>
                    </div>

                    <div class="info-item" v-if="hasName('accAddress')">
                        <span class="info-item__label">户籍地址：</span>
                        <span class="info-item__value">
                            <span>
                                <span v-if="signupInfo.stuPropertyList[0].accProvName">
                                {{signupInfo.stuPropertyList[0].accProvName}}&nbsp;{{signupInfo.stuPropertyList[0].accCityName}}&nbsp;{{signupInfo.stuPropertyList[0].accCountyName}}
                            </span>
                                    {{signupInfo.stuPropertyList[0].accAddress}}
                                    {{signupInfo.stuPropertyList[0].accAddress ? '&nbsp;&nbsp;' : ''}}
                                    {{signupInfo.stuPropertyList[0].accDetAddress}}
                                    {{signupInfo.stuPropertyList[0].accDetSupplement ? '&nbsp;&nbsp;' : ''}}
                                    {{signupInfo.stuPropertyList[0].accDetSupplement}}
                                </span>
                        </span>
                    </div>
                    <div class="info-item" v-if="hasName('addressPhoto')">
                        <span class="info-item__label">户口本：</span>
                        <span class="info-item__value">
                            <image-previewer tag="richtext" viewclass="image-container" :images="signupInfo.addressPhotoPhoto">
                                <img v-for="(picItem, picIndex) in signupInfo.addressPhotoPhoto" class="image-container"
                                     :src="picItem.photoUrl"/>
                            </image-previewer>
                        </span>
                    </div>
                    <div class="info-item" v-if="hasName('otherCertificate') && signupInfo.otherCertificatePhoto && signupInfo.otherCertificatePhoto.length !== 0">
                        <span class="info-item__label">非本户籍地址户口证明：</span>
                        <span class="info-item__value">
                            <image-previewer tag="richtext" viewclass="image-container" :images="signupInfo.otherCertificatePhoto">
                                <img v-for="(picItem, picIndex) in signupInfo.otherCertificatePhoto" class="image-container"
                                     :src="picItem.photoUrl"/>
                            </image-previewer>
                        </span>
                    </div>
                </div>
            </div>

            <div class="section section--address-info">
                <div class="section-header">
                    产权信息
                    <div class="section-header__bottom-block">
                    </div>
                </div>
                <div class="section-body">
                    <div class="info-item" v-if="hasName('propertyType')">
                        <span class="info-item__label">产权类型：</span>
                        <span class="info-item__value">
                                <span>{{signupInfo.stuPropertyList[0].propertyTypeName}}</span>
                            </span>
                    </div>
                    <div class="info-item" v-if="hasName('propertyTypeRemark') && signupInfo.stuPropertyList[0].propertyTypeCode == 109">
                        <span class="info-item__label">产权类型备注：</span>
                        <span class="info-item__value">
                                <span>{{signupInfo.stuPropertyList[0].propertyTypeRemark}}</span>
                            </span>
                    </div>
                    <div class="info-item" v-if="hasName('propertyNo')">
                        <span class="info-item__label">产权/租赁证号：</span>
                        <span class="info-item__value">
                                <span>{{signupInfo.stuPropertyList[0].propertyNo}}</span>
                            </span>
                    </div>

                    <div class="info-item" v-if="hasName('propertyHolder')">
                        <span class="info-item__label">所有产权人姓名：</span>
                        <span class="info-item__value">
                                <span>{{signupInfo.stuPropertyList[0].propertyHolder}}</span>
                            </span>
                    </div>

                    <div class="info-item" v-if="hasName('propertyRelation')">
                        <span class="info-item__label">产权关系：</span>
                        <span class="info-item__value">
                            <span>{{signupInfo.stuPropertyList[0].propertyRelation | parsePropertyRelation}}</span>
                            <span v-if="2 == signupInfo.stuPropertyList[0].propertyRelation">（面审当天需要带无房证明）</span>
                        </span>
                    </div>

                    <div class="info-item" v-if="hasName('propertyRatio') && signupInfo.stuPropertyList[0].propertyRelation == 8">
                        <span class="info-item__label">产权占比：</span>
                        <span class="info-item__value">
                            <span v-if="ratioItem.name" v-for="ratioItem in signupInfo.propertyRatioList">产权人：{{ratioItem.name}}&nbsp;&nbsp;关系：{{ratioItem.relation}}</span>
                        </span>
                    </div>
                    <div class="info-item" v-if="hasName('propertyNaProve') && signupInfo.stuPropertyList[0].propertyRelation == 2">
                        <span class="info-item__label">无房证明：</span>
                        <span class="info-item__value">
                            <image-previewer tag="richtext" viewclass="image-container" :images="signupInfo.propertyNaProvePhoto">
                                <img v-for="(picItem, picIndex) in signupInfo.propertyNaProvePhoto" class="image-container"
                                     :src="picItem.photoUrl"/>
                            </image-previewer>
                        </span>
                    </div>
                    <div class="info-item" v-if="hasName('propertyAddress') && signupInfo.stuPropertyList[0].propertyRelation != 6">
                        <span class="info-item__label">产权地址：</span>
                        <span class="info-item__value">
                            <span>
                                {{signupInfo.stuPropertyList[0].propertyAddress}}
                                {{signupInfo.stuPropertyList[0].propertyAddress ? '&nbsp;&nbsp;' : ''}}
                                {{signupInfo.stuPropertyList[0].propertyDetAddress}}
                                {{signupInfo.stuPropertyList[0].propertyDetSupplement ? '&nbsp;&nbsp;' : ''}}
                                {{signupInfo.stuPropertyList[0].propertyDetSupplement}}
                            </span>
                        </span>
                    </div>
                    <div class="info-item" v-if="hasName('propertyTime') && signupInfo.stuPropertyList[0].propertyRelation != 6">
                        <span class="info-item__label">产权登记时间：</span>
                        <span class="info-item__value">
                                <span> {{signupInfo.stuPropertyList[0].propertyTime}}</span>
                            </span>
                    </div>
                    <div class="info-item" v-if="hasName('propertyArea') && signupInfo.stuPropertyList[0].propertyRelation != 6">
                        <span class="info-item__label">建筑面积：</span>
                        <span class="info-item__value">
                                <span> {{signupInfo.stuPropertyList[0].propertyArea}}</span>
                            </span>
                    </div>
                    <div class="info-item" v-if="hasName('qiuNo') && signupInfo.stuPropertyList[0].propertyRelation != 6">
                        <span class="info-item__label">丘权号：</span>
                        <span class="info-item__value">
                                <span> {{signupInfo.stuPropertyList[0].qiuNo}}</span>
                            </span>
                    </div>
                    <div class="info-item" v-if="hasName('sectionNo') && signupInfo.stuPropertyList[0].propertyRelation != 6">
                        <span class="info-item__label">路段号：</span>
                        <span class="info-item__value">
                                <span> {{signupInfo.stuPropertyList[0].sectionNo}}</span>
                            </span>
                    </div>
                    <div class="info-item" v-if="hasName('isLive')">
                        <span class="info-item__label">是否实际居住：</span>
                        <span class="info-item__value">
                                <span> {{signupInfo.stuPropertyList[0].isLive === 1 ? '是' : '否'}}</span>
                            </span>
                    </div>

                    <div class="info-item" v-if="hasName('actualAddress') && signupInfo.stuPropertyList[0].isLive == 2">
                        <span class="info-item__label">实际居住地址：</span>
                        <span class="info-item__value">
                            <span>
                                <span v-if="signupInfo.actualProvName">{{signupInfo.actualProvName}}&nbsp;{{signupInfo.actualCityName}}&nbsp;{{signupInfo.actualCountyName}}</span>
                                {{signupInfo.actualAddress}}
                            </span>
                        </span>
                    </div>
                    <div class="info-item" v-if="hasName('liveMembers') && signupInfo.stuPropertyList[0].isLive == 1">
                        <span class="info-item__label">实际居住人员：</span>
                        <span class="info-item__value">
                                <span> {{signupInfo.stuPropertyList[0].liveMembers}}</span>
                            </span>
                    </div>
                    <div class="info-item" v-if="hasName('propertyPhoto') && signupInfo.propertyPhotoPhoto && signupInfo.propertyPhotoPhoto.length !== 0 && signupInfo.stuPropertyList[0].propertyRelation != 6">
                        <span class="info-item__label">产权证照片：</span>
                        <span class="info-item__value">
                            <image-previewer tag="richtext" viewclass="image-container" :images="signupInfo.propertyPhotoPhoto">
                                <img v-for="(picItem, picIndex) in signupInfo.propertyPhotoPhoto" class="image-container"
                                     :src="picItem.photoUrl"/>
                            </image-previewer>
                        </span>
                    </div>
                    <div class="info-item" v-if="hasName('houseDetailsPhotos') && signupInfo.houseDetailsPics && signupInfo.houseDetailsPics.length !== 0 && signupInfo.stuPropertyList[0].propertyRelation != 6">
                        <span class="info-item__label">房屋信息照：</span>
                        <span class="info-item__value">
                            <image-previewer tag="richtext" viewclass="image-container" :images="signupInfo.houseDetailsPics">
                                <img v-for="(picItem, picIndex) in signupInfo.houseDetailsPics" class="image-container"
                                     :src="picItem.photoUrl || picItem.fileUrl"/>
                            </image-previewer>
                        </span>
                    </div>
                    <div class="info-item" v-if="hasName('propertyRemark')" style="clear: both;width: 98%; float: none;">
                        <span class="info-item__label" style="width: 16%">备注：</span>
                        <span class="info-item__value">
                            {{signupInfo.stuPropertyList[0].propertyRemark}}
                        </span>
                    </div>
                </div>
                <div v-if="hasName('propertyRemark')">
                </div>
            </div>
            <div class="notify notify--confirm" v-if="state !== 0 && confirmText !== ''">
                {{confirmText}}
            </div>
            <div :class="['notify', this.signupInfo.stuInterviewInfo.isPrint != 1 ? 'notify--not-print' : '']" v-html="parseHtmlFormat(signupInfo.stuInterviewInfo.content)" v-if="this.signupInfo.stuInterviewInfo && this.signupInfo.stuInterviewInfo.content">
            </div>
        </div>

    </div>
</template>

<script>
    import ImagePreviewer from '@/components/ImagePreviewer/ImagePreviewer.vue';
    import {regionData, CodeToText} from '@/utils/element-china-area-data'
    import baseMixin from '@/mixins/baseMixin';

    import BackTool from '@/components/BackTool';

    import {
        getFieldSetInfo,
        getStuInfoByToken,
        getNotice
    } from '@/api/primary/outer';

    import {
        findDicsByCode,
        findSchoolDicsByCode,
        queryById
    } from '@/api/common';

    import moment from 'moment';

    export default {
        name: "questionnaireDetail",
        components: {
            BackTool,
            ImagePreviewer
        },
        mixins: [baseMixin],
        data: function () {
            return {
                schoolId: this.$route.query.schoolId,
                noticeId: this.$route.query.noticeId,
                stuName: this.$route.query.stuName,
                loginPhone: this.$route.query.loginPhone,
                options: regionData,
                userId: this.$route.query.userId,
                id: this.$route.query.id,
                updateId: null,
                fieldNameList: [],

                nationList: [],
                propertyTypeList: [],
                teachAreaList: [],

                isAdd: false,
                signupInfo: {
                    father: {},
                    mather: {}
                },
                isEnd: true,
                state: 0,
                offlineState: null,
                orderNo: 0,
                confirmText: '',

                createYear: '',
                schoolName: ''
            }
        },
        filters: {
            getNodeTypeText(value) {
                if (value === '' || value === null) {
                    return ''
                } else {
                    return ['非农业户口', '农业户口', ''][value];
                }
            },
            parsePropertyRelation(value) {
                if (!value) {
                    return ''
                } else {
                    return ['', '孩子父母独立产权', '“四老”房产', '与老人共有房产', '拆迁过渡', '军产房', '无房户口空挂', '集体户口', '与他人共有产权', '其他'][value];
                }
            },
            parseHolderRelation(value) {
                if (!value) {
                    return ''
                } else {
                    return ['', '父子/父女', '母子/母女', '祖孙', '其它'][value];
                }
            }
        },
        created() {
            if(this.$route.query.outerToken && !sessionStorage.getItem('outerToken')) {
                sessionStorage.setItem('outerToken', this.$route.query.outerToken);
            }
            getNotice({
                noticeId: this.noticeId
            })
                .then(res => res.data)
                .then(data => {
                    if (data.result) {
                        this.isEnd = data.data.noticeState === 3;
                        if(data.data.createTime) {
                            this.createYear = data.data.createTime.split('-')[0];
                        }
                    }
                });
            findDicsByCode({
                dicCode: 'national'
            })
                .then(res => res.data)
                .then(data => {
                    this.nationList = data.data;
                });

            findDicsByCode({
                dicCode: 'propertyType'
            })
                .then(res => res.data)
                .then(data => {
                    this.propertyTypeList = data.data;
                });

            queryById({
                id: this.schoolId
            })
                .then(res => res.data)
                .then(data => {
                    this.schoolName = data.data.name;
                    findSchoolDicsByCode({
                        schoolId: this.schoolId,
                        dicCode: data.data.type === 2 ? 'primaryTeachAreas' : 'middleTeachAreas'
                    })
                        .then(res => res.data)
                        .then(data => {
                            this.teachAreaList = data.data;
                        })
                });

            getFieldSetInfo({
                schoolId: this.schoolId,
                yearNo: moment().format('YYYY')
            })
                .then(res => res.data)
                .then(data => {
                    this.fieldNameList = data.data.map(item => item.fieldName);

                    if(this.hasName('confirmHint')) {
                        this.confirmText = data.data.find(({fieldName}) => fieldName === 'confirmHint').fieldRemark;
                    }

                    getStuInfoByToken({
                        token: sessionStorage.getItem('outerToken')
                    })
                        .then(res => res.data)
                        .then(data => {
                            this.initData(data.data);
                        });
                })
        },
        methods: {
            parseHtmlFormat(text) {
                const result = text.replace(/[\n\s]/g, function(catched) {
                    let result = '';
                    switch(catched) {
                        case '\n':
                            result = '<br />';
                            break;
                        case ' ':
                            result = '&nbsp;';
                            break;
                    }
                    return result;
                });
                return result;
            },
            print() {
                this.$print(this.$refs.print)
            },
            initData(sourceData) {
                this.state = sourceData.state;
                this.offlineState = sourceData.offlineState;
                this.orderNo = sourceData.orderNo;

                if (sourceData.stuBasicPicList) {
                    const stuBasicPic = sourceData.stuBasicPicList;

                    const propMapping = [
                        '',
                        'birthProvePhoto',
                        'vaccinateProvePhoto',
                        'childPhotoPhoto',
                        'isOnlyChildPhoto',
                        'isSoldierChildPhoto',
                        'addressPhotoPhoto',
                        'propertyPhotoPhoto',
                        'isSingleParentPhoto',
                        'isMajorDisPhoto',
                        // 'isBigBoyPhoto',
                        'propertyNaProvePhoto',
                        'otherCertificatePhoto'
                    ];
                    stuBasicPic.forEach(picItem => {
                        picItem.src = picItem.photoUrl;
                        if (sourceData[propMapping[picItem.itemType]]) {
                            sourceData[propMapping[picItem.itemType]].push(picItem);
                        } else {
                            sourceData[propMapping[picItem.itemType]] = [picItem];
                        }

                    })
                }
                if(sourceData.stuPropertyList && sourceData.stuPropertyList[0] && sourceData.stuPropertyList[0].propertyRatio) {
                    sourceData.propertyRatioList = JSON.parse(sourceData.stuPropertyList[0].propertyRatio);
                } else {
                    sourceData.propertyRatioList = [];
                }
                if(sourceData.healthTravelPics) {
                    sourceData.healthTravelPics = JSON.parse(sourceData.healthTravelPics);
                }
                console.log('sourceData', sourceData);
                if(sourceData.stuPropertyList && sourceData.stuPropertyList[0]) {
                    if(sourceData.stuPropertyJson) {
                        const stuProperty = JSON.parse(sourceData.stuPropertyJson);
                        if(stuProperty.length !== 0 && stuProperty[0].houseDetailsPics) {
                            sourceData.houseDetailsPics = stuProperty[0].houseDetailsPics;
                        }
                    } else if(sourceData.stuPropertyList[0].houseDetailsPics) {
                        sourceData.houseDetailsPics = JSON.parse(sourceData.stuPropertyList[0].houseDetailsPics);
                    }

                }
                this.signupInfo = sourceData;
            },
            hasName(name) {
                return this.fieldNameList.indexOf(name) !== -1;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../styles/mixin";

    @include globalstyle;
    /*===================== global resetting ============*/

    /*=============== base ==================*/
    body {
        background-color: #5D5D5D;

    }
    .notify {
        color: #ff0000;
    }
    .notify--confirm {
        margin-bottom: 20px;
    }

    .global-container {
        background-color: #fff;
        overflow-x: hidden;
        overflow-y: auto;
    }

    .icon {
        width: 30px;
        height: 30px;
        display: inline-block;
        vertical-align: middle;
        background: no-repeat center center / cover;
    }

    .icon--record {
        background-image: url(../../../assets/images/primary/icon-record2.png);
        position: relative;
        top: -2px;
        margin-right: 10px;
    }

    .icon--score {
        background-image: url(../../../assets/images/primary/icon-score.png);
        position: relative;
        top: -2px;
        margin-right: 10px;
    }

    .icon--honor {
        background-image: url(../../../assets/images/primary/icon-honor.png);
        position: relative;
        top: -2px;
        height: 26px;
        width: 26px;
        margin-right: 10px;
    }

    .icon--duty {
        background-image: url(../../../assets/images/primary/icon-duty.png);
        position: relative;
        top: -2px;
        height: 24px;
        width: 24px;
        margin-right: 10px;
    }

    .icon--prize {
        background-image: url(../../../assets/images/primary/icon-prize.png);
        position: relative;
        top: -2px;
        height: 24px;
        width: 24px;
        margin-right: 10px;
    }

    .icon--sport {
        background-image: url(../../../assets/images/primary/icon-sport.png);
        position: relative;
        top: -2px;
        height: 24px;
        width: 24px;
        margin-right: 10px;
    }

    /*=============== studentInfo =============*/
    .header {
        height: 54px;
        box-sizing: border-box;
        border-top: 10px solid #22A98B;
        color: #7B7B7B;
        line-height: 44px;
        padding-left: 16px;
    }

    .section-header {
        position: relative;
        height: 40px;
        line-height: 40px;
        font-size: 20px;
        /*color: rgb(64, 158, 255);*/
        font-weight:bold;
    }
    .section-header__bottom-block {
        position: absolute;
        box-sizing: border-box;
        width: 380px;
        color: #fff;
        background: linear-gradient(to right, rgba(64, 158, 255, 1),  rgba(64, 158, 255, 0.1));
        height: 8px;
        font-size: 20px;
    }

    .section-body {
        padding: 20px 0 10px 0;
        clear: both;
    }

    .section-body:after {
        visibility: hidden;
        display: block;
        font-size: 0;
        content: " ";
        clear: both;
        height: 0;
    }

    .section-body__left-block {
        float: left;
    }

    .section-body__right-block {
        float: left;
        margin-left: 10px;
    }

    .section--general-info .section-body__left-block {
        width: 270px;
    }

    .section--general-info .section-body__right-block {
        width: 500px;
    }

    .student-photo {
        width: 180px;
        margin: 0 auto;
        background: no-repeat center center / cover;
    }

    .student-name {
        font-size: 34px;
        width: 324px;
        text-align: center;
        margin-bottom: 20px;
    }



    .student-info-item__label, .student-info-item__value {
        display: inline-block;
        font-size: 18px;
    }

    .student-info-item__label {
        vertical-align: top;
        width: 170px;
        margin-right: 15px;
        text-align: right;
    }

    .student-info-item__value {
        width: 310px;
        color: #777;
    }

    .info-item {
        margin-bottom: 10px;
    }

    .info-item > * {
        display: inline-block;
        vertical-align: middle;
        font-size: 16px;
    }

    .info-item__label {
        color: #409EFF;
        width: 20%;
        margin-right: 30px;
        text-align: right;
    }

    .info-item__value {
        width: 58%;
        color: #464A4B;
    }

    .section--address-info .info-item__label {
        vertical-align: top;
    }

    .parent-info-container:first-child {
        float: left;
    }
    .section-body--parent {
        padding: 20px 30px 0 30px;
        .info-item__label {
            margin-right: 10px;
            width: 32%;
        }
        .info-item__value {
            width: 58%;
        }
    }

    .parent-info-container {
        width: 49%;
        float: left;
        box-sizing: border-box;
    }

    .info-item__value > * {
        display: block;
        word-break: break-all;
    }

    .sub-info {
        font-size: 12px;
    }

    .image-container {
        width: 40px;
        height: 40px;
        background: no-repeat center center / cover;
        float: left;
        margin: 0 5px 5px 0;
    }

    .section--verify-info .info-item__label {
        width: 200px;
        margin-right: 50px;
        vertical-align: top;
        color: #464A4B;
    }

    .section--verify-info .info-item__value {
        width: 550px;
    }

    .section--verify-info .info-item__label span {
        width: 90px;
        display: inline-block;
    }

    .personal-info__title {
        margin-bottom: 10px;
        color: #409EFF;
        font-size: 18px;
    }

    .personal-info__item > * {
        display: inline-block;
    }

    .personal-info__item-label {
        margin-bottom: 10px;
        color: #409EFF;
        width: 120px;
        margin-right: 30px;
    }

    .personal-info__item-value {
        width: 540px;
        color: #464A4B;
    }

    .score-item, .honor-item, .duty-item {
        margin-right: 20px;
    }

    .score-item > * {
        margin-right: 7px;
    }

    .line-container {
        clear: both;
        padding: 0 20px;
    }

    .pic-container {
        padding: 5px 0;
        width: 49%;
        box-sizing: border-box;
        float: left;
        .info-item__label {
            text-align: left;
        }
        .pic {
            margin-left: 10px;
            display: inline-block;
            vertical-align: top;
        }
        .info-item__label {
            display: inline-block;
            width: 12em;
        }
    }

    .pic-item {
        width: 80px;
        height: 80px;
        background: no-repeat center center / cover;
        display: inline-block;
        margin: 0 10px 10px 0;
    }

    .section {
        clear: both;
    }
    .section--character-card .sub-section {
        border-top: 1px solid #23A68B;
        margin: 0 auto;
        width: 750px;
        box-sizing: border-box;
        padding: 0 25px;
    }

    .personal-info-entry {
        font-size: 16px;
        margin-top: 30px;
    }

    .personal-info-section:first-child {
        border: 0;
    }

    .personal-info-section > *:first-child {
        margin-top: 0;
    }

    .personal-info__bottom-line, .sub-section-item__bottom-line {
        width: 40%;
        height: 5px;
        background-color: #23A68B;
    }

    .personal-info-entry:last-child .personal-info__bottom-line {
        display: none;
    }

    .sub-section-item:last-child .sub-section-item__bottom-line {
        display: none;
    }

    /*=============== 专长==========*/
    .sub-section__title {
        margin-bottom: 10px;
        color: #409EFF;
        padding-top: 30px;
        font-size: 18px;
    }

    .sub-section-item {
        font-size: 16px;
        margin-bottom: 10px;
        position: relative;
    }

    .sub-section-item .sub-section-item__pic-container {
        padding: 10px 0;
    }

    .sub-section-item > span {
        margin: 0 5px;
        color: #9E9E9E;
    }

    .sub-section-item .sub-section-item__name {
        display: inline-block;
        min-width: 60px;
        font-weight: bold;
        margin-right: 20px;
        color: #333;
    }

    #print_div {
        display: none;
    }

    .printRemindMsg {
        display: none;
    }

    .remindMsg {
        display: block;
    }

    @media print {
        #content * {
            color: #000 !important;
        }
        .section-header__bottom-block {
            width: 250px !important;
        }
        .notify--not-print {
            display: none !important;
        }
        #print_div {
            display: block;
        }
        .header {
            font-size: 34px !important;
        }
        .section--verify-info .info-item__label span {
            width: 80px !important;
        }
        * {
            -webkit-print-color-adjust: exact;
        }
        .section-header__bottom-block {
            background-color: #409EFF !important;
            color: #fff !important;
        }
        .sub-section__title {
        }
        .icon {
            width: 30px !important;
            height: 30px !important;
            display: inline-block !important;
            vertical-align: middle !important;
            background: no-repeat center center / cover !important;
        }
        .icon--record {
            background-image: url(../../../assets/images/primary/icon-record2.png) !important;
        }
        .icon--score {
            background-image: url(../../../assets/images/primary/icon-score.png) !important;
        }
        .icon--honor {
            background-image: url(../../../assets/images/primary/icon-honor.png) !important;
        }
        .icon--duty {
            background-image: url(../../../assets/images/primary/icon-duty.png) !important;
        }
        .icon--prize {
            background-image: url(../../../assets/images/primary/icon-prize.png) !important;
        }
        .icon--sport {
            background-image: url(../../../assets/images/primary/icon-sport.png) !important;
        }

        #print_div .section-body__right-block {
            width: 500px !important;
        }
        #print_div .section-body__right-block .student-info-item__value {
            width: 310px !important;
        }
        #print_div .info-item__value {
            width: 560px !important;
        }
        #print_div .student-info-item__label, #print_div .student-info-item__value {
            font-size: 20px;
        }
        #print_div .info-item > * {
            font-size: 20px;
        }

        .printRemindMsg {
            display: block;
        }
        .remindMsg {
            display: none;
        }
    }
    .second-header-wrap {
        left: 0;
        width: 900px;
        height: 60px;
        line-height: 60px;
        padding: 5px 0;
        background-color: #fff;
        z-index: 1000;
        margin: 0 auto;
    }
    .content {
        width: 900px;
        margin: 0 auto;
    }
    .review-list-container {
        float: left;
        width: 400px;
        margin-left: 50px;
    }
    .review-item {
        @include clearfix;
        margin-bottom: 10px;
        padding: 5px ;
        border-bottom: 1px solid #333;
        .review-item__state {
            float: left;
            width: 20%;
        }
        .review-item__detail {
            float: left;
            width: 78%;
        }
        .review-item__user {
            text-align: right;
            font-size: 14px;
            color: #333;
        }
    }
    .order-no {
        margin-right: 10px;
        font-size: 20px;
        color: #ff0000;
        font-weight: bold;
    }
    .section--address-info {
        .section-body {
            padding: 20px 30px 0 30px;
        }
        .info-item {
            float: left;
            width: 49%;
            box-sizing: border-box;

            .info-item__label {
                width: 32%;
                margin-right: 10px;
            }
        }
    }
    .photo-fill.section-body__left-block {
        width: 3.5cm;
        height: 4.9cm;
        border: 1px dashed #333;
        margin-left: 50px;
        margin-top: 30px;
        line-height: 4.9cm;
        text-align: center;
    }
    .print-header {
        font-size: 26px;
        text-align: center;
        font-weight: bold;
        position: relative;
    }
</style>
<style lang="scss">
    #questionnaire {
        .address-box-item {
            line-height: 36px;
        }

        .el-checkbox, .el-checkbox__input {
            white-space: normal !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/primary/outer/OuterQuestionnaireDetail.vue